import { Pipe, PipeTransform } from "@angular/core";

//filter.ts
@Pipe({
    name: 'searchfilter'
})
export class FilterPipe implements PipeTransform {
    transform(items, searchTerm) {
        let filteredList = [];
        if (searchTerm) {
            let newSearchTerm = !isNaN(searchTerm) ? searchTerm.toString() : searchTerm.toString().toUpperCase();
            let prop;
            return items.filter(item => {
                let key = "name";
                //for (let key in item)
                {
                    prop = isNaN(item[key]) ? item[key].toString().toUpperCase() : item[key].toString();
                    if (prop.indexOf(newSearchTerm) > -1) {
                        filteredList.push(item);
                        return filteredList;
                    }
                }
            })
        }
        else {
            return items;
        }
    }

}

@Pipe({
    name: 'keyfilter'
})
export class ArchiveFilterPipe implements PipeTransform {
    transform(items, key) {
        let filteredList = [];
        if (key) {
            //let newSearchTerm = !isNaN(searchTerm) ? searchTerm.toString() : searchTerm.toString().toUpperCase();
            let prop;
            return items.filter(item => {

                //for (let key in item)
                {
                    if (item[key] == true) {
                        filteredList.push(item);
                        return filteredList;
                    }

                }
            })
        }
        else {
            return items;
        }
    }

}

@Pipe({
    name: 'sortfilter'
})
export class SortFilterPipe implements PipeTransform {
    transform(items, field) {
        let filteredList = [];
        if (field) {
            if (!Array.isArray(items)) {
                return;
            }
            let direction = '-';
            items.sort((a: any, b: any) => {
                let left = Number(new Date(a[field]));
                let right = Number(new Date(b[field]));
                return (direction === "-") ? right - left : left - right;
            });
            return items;
        }

    }

}


@Pipe({
    name: 'highlight',
    standalone: true
})
export class HighlightPipe implements PipeTransform {

    transform(value: string, searchTerm: string, isExact: boolean = false): string {
        if (!searchTerm) return value;

        // Split search terms by spaces and process each term
        const terms = searchTerm
            .split(' ')
            .map(term => {
                // Only extract value after "=" if term starts with "rating=" or "class="
                if (term.toLowerCase().startsWith('rating=')) {
                    return term.split('=')[1];
                } else if (term.toLowerCase().startsWith('class=')) {
                    return isExact ? "Curve class" : term.split('=')[1];
                } else if (term.toLowerCase().startsWith('tripunit=')) {
                    return isExact ? "Trip unit" : term.split('=')[1];
                } else if (term.toLowerCase().startsWith('curve=')) {
                    return isExact ? "Curve class" : term.split('=')[1];
                } else if (term.toLowerCase().startsWith('curveclass=')) {
                    return isExact ? "Curve class" : term.split('=')[1];
                } else if (term.toLowerCase().startsWith('fusetype=')) {
                    return isExact ? "Fuse type" : term.split('=')[1];
                }
                return term;
            })
            .filter(term =>
                term &&
                !['a', 'an'].includes(term.toLowerCase())  // Remove "a" and "an"
            )
            .map(term => term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')) // Escape special characters for regex
            .sort((a, b) => b.length - a.length); // Sort terms by length in descending order

        if (terms.length === 0) return value; // If no terms left, return the original value

        // Create a single regular expression to match any of the words.
        const re = new RegExp(`(${terms.join('|')})`, 'gi');

        // Replace matched words with <mark> tag
        return value.replace(re, '<mark>$1</mark>');
    }
}

@Pipe({
    name: 'orderBy'
  })
  export class OrderByPipe implements PipeTransform {
  
    transform(array: any[], field: string, reverse: boolean = false): any[] {
      if (!Array.isArray(array)) return array;
  
      return [...array].sort((a, b) => {
        const aVal = a[field];
        const bVal = b[field];
  
        if (typeof aVal === 'string' && typeof bVal === 'string') {
          const aLower = aVal.toLowerCase();
          const bLower = bVal.toLowerCase();
  
          if (aLower < bLower) return reverse ? 1 : -1;
          if (aLower > bLower) return reverse ? -1 : 1;
          return 0; 
        }
  
        if (aVal < bVal) return reverse ? 1 : -1;
        if (aVal > bVal) return reverse ? -1 : 1;
        return 0;
      });
    }
  }
  